export { default, type FullscreenVideoSectionProps } from './FullscreenVideoSection';
